import DashboardStore from "../DashboardStore";
import React, { FC, useEffect, useState } from "react";
import { AreaChart, Area, XAxis, Tooltip, ResponsiveContainer } from "recharts";
import SubscriptionIcon from "../../../../../../images/membership/recurring.svg";
import {  DashboardService } from "../../../shared/services";
import {
  AuthService,
  CustomLabel,
  FlexContainer,
  Loader,
  SapphireBlueButton,
  ToastService,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import { SubscriptionActivityModel } from "../../../shared/models";
import { AccountSettingsStore } from "../../../shared/store";

type IProps = {
  dashboardStore: DashboardStore;
  merchantAccountId: string;
};
const ActiveSubscriptionsWidget: FC<IProps> = ({
  dashboardStore,
  merchantAccountId,
}) => {
  const [showLoader, setLoader] = useState(false);
  useEffect(() => {
    if (!merchantAccountId) return;
    setLoader(true);
    DashboardService.getSubscriptionsActivity(
      AuthService.authData.accountId,
      merchantAccountId
    ).subscribe({
      next: (response) => {
        setLoader(false);
        const mappedData = SubscriptionActivityModel.deserializeAPIModel(
          response.result
        );
        dashboardStore.updateSubscriptionActivities(mappedData);
      },
      error: () => {
        ToastService.showError("Error Occured");
      },
    });
  }, [merchantAccountId]);

  if (showLoader || !dashboardStore.subscriptionWidgetData)
    return <>{new Loader(true).loaderComponent}</>;

  const amount =
    "$" +
    AccountSettingsStore.formatAmount(
      dashboardStore.subscriptionWidgetData.totalAmount,
      true
    );
  return (
    <>
      <FlexContainer
        justifyContent="space-between"
        className="activity-header-wrapper"
      >
        <div>
          <FlexContainer
            alignItems="center"
            spacing={10}
            padding="0px 0px 30px"
          >
            <img src={SubscriptionIcon} />
            <div className="activity-card-header">Active Subscriptions</div>
          </FlexContainer>
        </div>
        <div>
          <SapphireBlueButton>View</SapphireBlueButton>
        </div>
      </FlexContainer>
      <div className="subscriptions-graph">
        <FlexContainer
          justifyContent="space-between"
          alignItems="center"
          padding="0px 0px 25px"
          className="graph-sub-header"
        >
          <div>
            <FlexContainer fxLayout="column" alignItems="center" spacing={15}>
              <CustomLabel>Recurring Monthly</CustomLabel>
              <CustomLabel>{amount}</CustomLabel>
            </FlexContainer>
          </div>
          <div>
            <FlexContainer fxLayout="column" alignItems="center" spacing={15}>
              <CustomLabel>Total</CustomLabel>
              <CustomLabel>
                {UtilityMethods.numberWithCommas(
                  dashboardStore.subscriptionWidgetData.total
                )}
              </CustomLabel>
            </FlexContainer>
          </div>
          <div>
            <FlexContainer fxLayout="column" alignItems="center" spacing={15}>
              <CustomLabel>Past Due</CustomLabel>
              <CustomLabel>
                {UtilityMethods.numberWithCommas(
                  dashboardStore.subscriptionWidgetData.totalPastDue
                )}
              </CustomLabel>
            </FlexContainer>
          </div>
        </FlexContainer>
        <CustomLabel fontSize={"14px"}>New Subscriptions</CustomLabel>
        <ResponsiveContainer height={200}>
          <AreaChart
            width={600}
            height={200}
            data={dashboardStore.subscriptionWidgetData.graphData}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <XAxis
              dataKey="label"
              interval="preserveStart"
              tickLine={false}
              axisLine={false}
            />

            <Tooltip />
            <Area
              type="monotone"
              dataKey="total"
              stroke="#8884d8"
              fill="#8884d8"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default ActiveSubscriptionsWidget;
